import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ClassDetailsCard from "./ClassDetailsCard";
import ScheduledClassCard from "./ScheduledClassCard";
import PrimarySmallBlueButton from "../../../components/customButtons/PrimarySmallBlueButton";
import SessionDetailsCard from "./SessionDetailsCard";
import { fetchEnrolledClassDetails } from "../../testPrepDashboard/Api/DashboardApi";
import CustomPopup from "../../../components/customPopup/CustomPopup";
import UpgradeClassForm from "./UpgradeClassForm";
import Loader from "../../../../SAPPages/components/Loader/Loader";
import SussceeffulyMessageScreen from "../../../components/customPopup/SussceeffulyMessageScreen";
import LessonPlanner from "./LessonPlan";

export default function SelectedClassDetails() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [classDetails, setClassDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
const [openUpgradeForm, setOpenUpgradeForm] =useState(false)
  const { std_class_detail_id } = useParams();
   const currentDate = new Date().toISOString().split("T")[0];

     const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
      const [errorMessage, setErrorMessage] = useState("");

  const handleFetchClassDetails = async () => {
    setLoading(true);
    try {
      const response = await fetchEnrolledClassDetails({
        // user_id: parseInt(userId),
        user_id: parseInt(userId),
        std_class_detail_id: std_class_detail_id,
      });

      if (response.status === 200) {
        setClassDetails(response?.data);
        setLoading(false);
      } else {
        setClassDetails([]);
        setLoading(false);
      }
    } catch (error) {
      setClassDetails([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchClassDetails();
  }, []);


  const handleOpenUpgradePopup =()=>{
    setOpenUpgradeForm(true)
  }

  const handleCloseUpgradePopup =()=>{
    setOpenUpgradeForm(false)
  }

    const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Grid
            container
            gap={2}
            alignItems="center"
            onClick={() => navigate("/test-prep/classroom")}
            sx={{ cursor: "pointer" }}
          >
            <Box width={32}>
              <img src="/newdashboard/Classrom/wishlist.png" />
            </Box>
            <Typography
              textAlign="start"
              color="#572575"
              fontFamily="Inter"
              fontSize="24px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Class Details
            </Typography>
          </Grid>
        </Grid>

{currentDate>=classDetails?.enrollment_date && ( 
        <Grid item xs={12} sm={6} textAlign="end">
          <PrimarySmallBlueButton buttonTitle="Upgrade Class" onClick={handleOpenUpgradePopup} />
        </Grid>
)}

{loading ? (
  <Grid item xs={12}>
    <Loader text="loading class details ..."/>
  </Grid>
) : ( 
 

        <Grid item xs={12} height="100%">
          <Grid container spacing={2}  sx={{ display: "flex", alignItems: "stretch" }}>
            <Grid item xs={12} sm={12} md={4} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
             
             
                  <ClassDetailsCard classDetails={classDetails} />
             
                  {/* <ScheduledClassCard classDetails={classDetails} /> */}
                  <LessonPlanner classDetails={classDetails} />
      
            </Grid>

            <Grid item xs={12} sm={12} md={8}  sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <SessionDetailsCard classDetails={classDetails} />
            </Grid>
          </Grid>
        </Grid>
)}
      </Grid>

         <CustomPopup
              handleClose={handleCloseUpgradePopup}
              component={
                <UpgradeClassForm
              handleClose={handleCloseUpgradePopup}
                   classData={classDetails}
               handleOpenSuccessPopup={handleOpenSuccessPopup}
               setErrorMessage={setErrorMessage}
               errorMessage={errorMessage}
                />
              }
              open={openUpgradeForm}
              titleColor="#000000"
              maxWidth="xs"
              titleAlign="center"
            />

             <SussceeffulyMessageScreen
                    text="Payment successful ! !"
                    subText={errorMessage}
                    buttonTitle="Thanks, Got it"
                
                     navigateLink={location.pathname}
                    currentLink={location.pathname}
                    handleClose={handleCloseSuccessPopup}
                    open={openSuccesPopup}
                  />
    </>
  );
}
